import React, { Component } from 'react';

import FinancialPlanHeader from '../../FinancialPlanHeaderView';

import ProgressChart from './ProgressChart/ProgressChartContainer';
import Explanations from '../../Explanations/ExplanationsContainer';
import { LONG_TERM_CARE } from '../InsuranceConstants';

export default class LongTermCareView extends Component {
  constructor(props) {
    super(props);
    this.onLongTermCareRef = this.onLongTermCareRef.bind(this);
  }

  onLongTermCareRef(element) {
    if (element !== this.container) {
      this.container = element;
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {}

  render() {
    const {
      isPrint,
      clientId,
      fpId,
      goalId,
      subgoalId,
      note,
      selectedSection,
      setSelectedOwnerIndex,
      selectedOwnerName,
      subgoalData,
      isCurrentPlan,
      selectedOwnerIndex,
    } = this.props;

    return (
      <div className="NewFinancialPlan_Insurance_LongTermCare" ref={this.onLongTermCareRef}>
        <div
          className={`NewFinancialPlan_header
                ${!this.props.showCalibration ? ' hide-calibration-button' : ''}
            `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            printTitle={`${LONG_TERM_CARE}: ${selectedOwnerName}`}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        <ProgressChart
          isPrint={isPrint}
          clientId={clientId}
          goalId={goalId}
          fpId={fpId}
          subgoalId={subgoalId}
          subgoalData={subgoalData}
          isCurrentPlan={isCurrentPlan}
          note={note}
          principalName={subgoalData.PrincipalName}
          spouseName={subgoalData.SpouseName}
          setSelectedOwnerIndex={setSelectedOwnerIndex(clientId, goalId)}
          {...(isPrint ? { ownerIndex: selectedOwnerIndex, tabId: subgoalId } : {})}
        />
      </div>
    );
  }
}
